import { z } from "zod";

export const addClientSchema = z.object({
  first_name: z
    .string()
    .min(1, "First name is required")
    .max(100, "First name must be 100 characters or less"),
  last_name: z
    .string()
    .min(1, "Last name is required")
    .max(100, "Last name must be 100 characters or less"),
  preferred_name: z
    .string()
    .max(100, "Preferred name must be 100 characters or less"),
  pronouns: z.string().max(50, "Pronouns must be 50 characters or less"),
  phone: z.string().max(20, "Phone must be 20 characters or less"),
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter a valid email address"),
  address: z.string().max(500, "Address must be 500 characters or less"),
  recommended_by: z
    .string()
    .max(255, "Recommended by must be 255 characters or less"),
  birthday: z.any().nullable(),
  notes: z.string().max(1000, "Notes must be 1000 characters or less"),
});
